// Max number of "countable" grid items (real products + product-break
// video banners) revealed at a time, whether that's the very first
// server-rendered page or a "Load More" click. page-break banners
// (class "grid__item2") are a different class and were never part of
// this count or this selector.
const VISIBLE_BATCH_SIZE = 24;

const products_on_page = document.getElementById('product-grid');
let next_url = products_on_page.dataset.nextUrl;
const load_more_btn = document.getElementsByClassName('load-more_btn')[0];

// Items already fetched (either sitting in the server-rendered first
// page, or pulled from a prior AJAX fetch) but not yet revealed, because
// revealing them would push the visible count past VISIBLE_BATCH_SIZE.
// These get appended first, before any new network request, on the next
// "Load More" click.
let pending_items = [];

// Cuts the grid down to at most VISIBLE_BATCH_SIZE li.grid__item elements,
// moving any overflow (in DOM order) into pending_items instead of
// discarding them. Used both for the initial server-rendered page and for
// each freshly fetched AJAX page.
function trimToVisibleBatch(gridEl) {
  const items = Array.from(gridEl.querySelectorAll('li.grid__item'));
  if (items.length <= VISIBLE_BATCH_SIZE) return;

  const overflow = items.slice(VISIBLE_BATCH_SIZE);
  overflow.forEach((item) => {
    item.parentNode.removeChild(item);
    pending_items.push(item);
  });
}

// Trim whatever the server already rendered on first load, before any
// "Load More" click happens, so the first paint also respects the cap.
trimToVisibleBatch(products_on_page);

async function getNextPage() {
  try {
    console.log(next_url);
    let res = await fetch(next_url);
    return await res.text();
  } catch (error) {
    console.log(error);
  }
}

async function loadMoreProducts() {
  await setTimeout(()=>{}, 1000);
  console.log("this is testing");
  load_more_btn.style.display = 'none';
  $('.load-more').addClass('active-loading');

  // Real product <li> elements AND product_breaks (video) banners count
  // towards the "viewed"/page-hit tracking below and towards the
  // VISIBLE_BATCH_SIZE cap for this click.
  let appended_product_count = 0;

  while (appended_product_count < VISIBLE_BATCH_SIZE) {
    if (pending_items.length === 0) {
      // Buffer is empty but we still owe items for this click (or there's
      // simply nothing left) — fetch the next page rather than stopping
      // early just because a previous batch happened to overflow.
      if (!next_url) break;

      let nextPage = await getNextPage();
      const parser = new DOMParser();
      const nextPageDoc = parser.parseFromString(nextPage, 'text/html');
      const productgrid = nextPageDoc.getElementById('product-grid');
      // All product / product-break <li> elements from the fetched page.
      // page_breaks banners (class "grid__item2") are not selected here,
      // same as before this change.
      pending_items = Array.from(productgrid.querySelectorAll('li.grid__item'));
      next_url = productgrid.dataset.nextUrl;

      if (pending_items.length === 0) break; // fetched page had nothing usable
    }

    const item = pending_items.shift();
    const breakKey = item.dataset.breakKey;

    if (breakKey && products_on_page.querySelector('[data-break-key="' + breakKey + '"]')) {
      // A banner can, in some configurations, be recalculated onto more than
      // one fetched page. If one with the same key is already in the grid,
      // skip it instead of appending a duplicate.
      continue;
    }

    products_on_page.appendChild(item);
    appended_product_count++;
  }

  // "Load More" stays visible as long as there's anything left to reveal,
  // whether that's still-buffered items or another page to fetch.
  if (pending_items.length > 0 || next_url) {
    load_more_btn.style.display = 'flex';
  }
  $('.load-more').removeClass('active-loading');

  if (appended_product_count > 0) {
      let pageHit = load_more_btn.getAttribute('data-page-hit');
      pageHit = parseInt(pageHit)+1;
      load_more_btn.setAttribute('data-page-hit',pageHit);
  }
  updateCollectionViewed();
}

var pathName = document.location.pathname;
async function loadNoOfPagesLoaded(round) {
  console.log("came here 43");
  console.log(round);

    console.log(round);
  document.body.classList.add("loading-state");
  let pageRound = parseInt(round) - 1;
  document.querySelector(".loading .total").innerHTML = pageRound;
  let pageLoaded = 1;
  let results = null;
  while (pageRound > 0) {
    document.querySelector(".loading .loaded").innerHTML = pageLoaded;
    results = await loadMoreProducts();
    console.log("this"+pageLoaded);
    pageLoaded++;
    pageRound--;
  }
  console.log(localStorage["scrollPosition_" + pathName]);
  console.log("came 86");
  if (localStorage["Temp_scrollPosition_" + pathName]) {
     $(document).scrollTop(localStorage.getItem("Temp_scrollPosition_" + pathName));
     localStorage.removeItem("Temp_scrollPosition_" + pathName);
  }
  else {
    if (localStorage["scrollPosition_" + pathName]) {
        $(document).scrollTop(localStorage.getItem("scrollPosition_" + pathName));
    }
  }
  document.body.classList.remove("loading-state");

}

/*
const perfEntries = performance.getEntriesByType('navigation');
if (perfEntries.length && perfEntries[0].type === 'back_forward') {
  if (localStorage["pagesCount_" + pathName]) {
      loadNoOfPagesLoaded(localStorage["pagesCount_" + pathName]);
  }
}
*/
if(localStorage.getItem("detectSafariLoad_" + pathName) == "true" && (localStorage["pagesCount_" + pathName])) {
   console.log(localStorage.getItem("scrollPosition_" + pathName));
  console.log("came 86");
   localStorage.setItem("Temp_scrollPosition_" + pathName, localStorage.getItem("scrollPosition_" + pathName));
}
// For Safri browser
document.addEventListener('DOMContentLoaded', function() {
   // your code here
  if(localStorage.getItem("detectSafariLoad_" + pathName) == "true" && (localStorage["pagesCount_" + pathName])) {
    localStorage.removeItem("detectSafariLoad_" + pathName);
    console.log(localStorage["pagesCount_" + pathName]);
    loadNoOfPagesLoaded(localStorage["pagesCount_" + pathName]);
  }
}, false);

if(performance.navigation.type == 2) {
    console.log(localStorage["pagesCount_" + pathName]);
    if (localStorage["pagesCount_" + pathName]) {
        loadNoOfPagesLoaded(localStorage["pagesCount_" + pathName]);
    }
}

window.onpageshow = function(event) {
    if (event.persisted) {
      var iOS = ['iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) >= 0;
      localStorage.setItem("detectSafariLoad_" + pathName,"true");
      if(!iOS) {
        localStorage.setItem("detectSafariLoad_" + pathName,"true");
      } else {
        if (localStorage["pagesCount_" + pathName]) {
             console.log("came inside");
             //loadNoOfPagesLoaded(localStorage["pagesCount_" + pathName]);
        }


      }
    }

};